<template lang="html">

  <div class="home" :bloqueada="!launched">

    <intro></intro>

    <section class="intro-fake">
      <intro></intro>
    </section>

    <div class="camino-container">

      <section :class="[launched ? 'launched' : '', 'page','comienza-experiencia']" id="comienza">

        <div class="titulo column-center">

          <span class="numero">1</span>

          <h3 class="title first -woline">
            <span>{{$t('home.comienza.titulo_uno')}}</span>
          </h3>

          <h3 class="title -woline">
            <span>{{$t('home.comienza.titulo_dos')}}</span>
            <span>{{$t('home.comienza.titulo_tres')}}</span>
          </h3>

        </div>

        <div class="contenedor-imagen row-center">

          <h4 class="title -ghost container">{{$t('home.comienza.experiencia_aldonza')}}</h4>

          <div class="texto">
            <p>{{$t('home.comienza.cuerpo')}}</p>
          </div>

          <div class="imagen" data="comienza-la-experiencia" @mouseover="playVideo('video-experiencia')"
            @mouseleave="pausevideo('video-experiencia')">
            <video controls="false" loop="true" muted="true" id="video-experiencia" playsinline>
              <source src="/static/video/video-experiencia.mp4" type="video/mp4">
            </video>
          </div>

        </div>

      </section>


      <section class="page la-finca row-center ais animation launch-video" id="la-finca">

        <div class="titulo column-center">

          <span class="numero">2</span>

          <h3 class="title -woline">
            <span>{{$t('home.la_finca.titulo_uno')}}</span>
            <span>{{$t('home.la_finca.titulo_dos')}}</span>
          </h3>

        </div>

        <div class="contenedor-imagenes row-center">

          <div class="left column-center plum-border -fixed -xl" data="tierra" @mouseover="playVideo('video-tierra')"
            @mouseleave="pausevideo('video-tierra')" :autoplay="ismovil">
            <p><span>{{$t('home.la_finca.cuerpo')}}</span></p>
            <router-link class="enlace-cover" :to="$t('enlaces.la_tierra')"></router-link>
            <router-link class="btn" :to="$t('enlaces.la_tierra')">
              <span><span>{{$t('vistas.la_tierra')}}</span></span>
            </router-link>

            <img src="/static/img/tripadvisor-blanco.png" alt="Logo Tripadvisor" class="logo-tripadvisor" />

            <video controls="false" loop="true" muted="true" id="video-tierra" playsinline>
              <source src="/static/video/video-lafinca.mp4" type="video/mp4">
            </video>

          </div>

          <div class="right column-start">

            <article class="column-center plum-border" data="bodega">
              <router-link class="btn" :to="$t('enlaces.la_bodega')">
                <span><span>{{$t('vistas.la_bodega')}}</span></span>
              </router-link>
              <a style="padding-top: 10px; text-align: center;" :href="$t('enlaces.mejor_bodega_CM')" target="_blank">
                <u style="font-weight: 500;">{{ $t('mejor_bodega_CM') }}</u>
              </a>
            </article>

            <article class="column-center plum-border" data="almanzara">
              <router-link class="enlace-cover" :to="$t('enlaces.la_almanzara')"></router-link>
              <router-link class="btn" :to="$t('enlaces.la_almanzara')">
                <span>{{$t('vistas.la_almazara')}}</span>
              </router-link>
            </article>
            <article class="column-center plum-border" data="azafran">
              <router-link class="enlace-cover" :to="$t('enlaces.sala_azafran')"></router-link>
              <router-link class="btn" :to="$t('enlaces.sala_azafran')">
                <span>{{$t('vistas.sala_azafran')}}</span>
              </router-link>
            </article>
            <article class="column-center plum-border" data="queseria">
              <router-link class="enlace-cover" :to="$t('enlaces.queseria')"></router-link>
              <router-link class="btn" :to="$t('enlaces.queseria')">
                <span>{{$t('vistas.queseria')}}</span>
              </router-link>
            </article>

           

          </div>

        </div>

        <h2 class="title -ghost">
          <span>{{$t('home.la_finca.aldonza_experience')}}</span>
        </h2>

      </section>


      <section class="page productos animation" id="productos">

        <div class="titulo column-center">

          <span class="numero">3</span>

          <h3 class="title -woline">
            <span>{{$t('home.productos.titulo')}}</span>
          </h3>

        </div>

        <slider-productos></slider-productos>

      </section>


      <section class="page experiencia animation" id="experiencias">

        <div class="titulo column-center">

          <span class="numero">4</span>

          <h3 class="title -woline">
            <span>{{$t('home.experiencia.titulo_uno')}}</span>
            <span>{{$t('home.experiencia.titulo_dos')}}</span>
          </h3>

          <h4 class="title -ghost">{{$t('home.experiencia.aldonza_experience')}}</h4>

        </div>

        <div class="container row-between banners" :active="experiencia">

          <div class="contenedor-vive">

            <article class="banner-vive-aldonza row-center plum-border" @mouseover="playVideo('video-vive-aldonza')"
              @mouseleave="pausevideo('video-vive-aldonza')">
              <video controls="false" loop="true" muted="true" id="video-vive-aldonza" playsinline>
                <source src="/static/video/video-vive-aldonza.mp4" type="video/mp4">
              </video>
              <router-link :to="$t('enlaces.vive_aldonza')" class="enlace-cover"></router-link>
              <router-link :to="$t('enlaces.vive_aldonza')" class="btn">
                <span>{{$t('vistas.vive_aldonza')}}</span>
              </router-link>
            </article>

          </div>

          <div class="contenedor-escucha">

            <article class="banner-escucha-aldonza column-center" @mouseover="playVideo('video-escucha')"
              @mouseleave="pausevideo('video-escucha')">
              <p>{{$t('home.experiencia.escucha_aldonza.cuerpo')}}</p>
              <router-link :to="$t('enlaces.escucha_aldonza')" class="enlace-cover"></router-link>
              <router-link :to="$t('enlaces.escucha_aldonza')" class="btn spotify row-start aic">
                <img src="/static/img/logo-spotify.png" height="48" alt="Spotify">
                <span>{{$t('vistas.escucha_aldonza')}}</span>
              </router-link>
              <video controls="false" loop="true" muted="true" id="video-escucha" playsinline>
                <source src="/static/video/video-escucha.mp4" type="video/mp4">
              </video>
            </article>

          </div>


        </div>

      </section>

      <section class="page blog animation column-center" id="blog">

        <div class="titulo column-center">

          <span class="numero">5</span>

        </div>

        <blog></blog>

      </section>

      <section class="page contacto contact animation" :id="$t('enlaces.contactoid')">

        <div class="titulo -black column-center">

          <span class="numero">6</span>

          <h3 class="title -black -woline">
            <span>{{$t('home.contacto.titulo')}}</span>
          </h3>

        </div>


        <div class="contenedor-banner">

          <banner-newsletter></banner-newsletter>

        </div>

      </section>

      <section class="contacto-movil" v-if="ismovil">
        <banner-contacto></banner-contacto>
      </section>



      <div class="contenedor-camino dibujado">
        <img src="/static/img/flecha.svg" class="down" alt="Bajar">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" viewBox="0 0 1059.1 4604" style="enable-background:new 0 0 1059.1 4604;" xml:space="preserve">

          <g>
            <g id="Symbols">
              <g id="Group-8">
                <path id="Stroke-3" class="st0"
                  d="M575.1,69.3c108.4,9.3,466.5,71.1,466.5,485.5c0,428.5-382.9,463.2-476.7,465.4" />
              </g>
            </g>
            <g id="Symbols-3">
              <g id="Group-8-3">
                <path id="Stroke-3-3" class="st0"
                  d="M571.3,1970.1c99.3,8.5,427.3,65.1,427.3,444.7c0,392.5-350.7,424.4-436.6,426.3" />
              </g>
            </g>
            <g id="Symbols-5">
              <g id="Group-8-5">
                <path id="Stroke-3-5" class="st1"
                  d="M481.3,3641.1c-91.3-7.8-393.4-59.9-393.4-409.4c0-361.4,322.9-390.8,402-392.5" />
              </g>
            </g>
            <g id="Symbols-3_1_">
              <g id="Group-8-3_1_">
                <path id="Stroke-3-3_1_" class="st2"
                  d="M572,3643.1c107.3,9.2,461.6,70.3,461.6,480.4c0,424-378.9,458.5-471.7,460.6" />
              </g>
            </g>
            <g>
              <path class="st3" d="M486.3,1019.2c-78,6.7-285.1,40.5-395.2,213.1" />
              <path class="st0" d="M17.5,1605.2c54.9,333.6,383,362.9,468.8,364.9" />
            </g>
          </g>
          <g>
          </g>
        </svg>



      </div>

    </div>

  </div>

</template>

<script lang="js">
  import blog from '@/components/parts/blog'
  import newsletter from '@/components/parts/banner-newsletter'

  import sliderProductos from '@/components/parts/slider-productos'

  import introHome from '@/components/views/home/intro-home'

  import { mapGetters, mapActions } from 'vuex';

  import bannerContacto from '@/components/parts/banner-contacto';

  require('waypoints/lib/noframework.waypoints.js')

  export default {
    name: 'home',
    mounted() {
      this.checkGoTo();
      this.pathFunction();
      this.waypoints();
      if (this.ismovil) {
        this.playVideo('video-tierra');
        this.playVideo('video-vive-aldonza');
      }

      if (this.$route.name == 'newsletter') {
        setTimeout(e => {
          $('html, body').animate({
            scrollTop: $("#contacto").offset().top
          }, 100);
        }, 1000)
      }


      var vids = $("video");
      $.each(vids, function () {
        this.controls = false;
      });

    },
    data() {
      return {
        experiencia: 'NS'
      }
    },
    methods: {
      ...mapActions(['changeLanguage']),
      checkGoTo: function () {
        if (!!this.$route.params.id) {
          this.$scrollTo(`.${this.$route.params.id}`);
        }
      },
      pathFunction: function () {

        window.addEventListener("scroll", scrollFunction);

        function scrollFunction() {

          var scroll = $(window).scrollTop() - $(window).height() / 2;

          if (scroll >= 200) {
            $(".contenedor-camino.dibujado").css('height', scroll + 240);
            $(".contenedor-camino.dibujado .down").fadeOut();
          }
        }
      },
      waypoints: function () {

        var waypoints = document.getElementsByClassName('animation');

        for (var i = 0; i < waypoints.length; i++) {

          new Waypoint({
            element: waypoints[i],
            offset: '360px',
            handler: function () {
              this.element.classList.add("launched")
            }
          });

        }

        var launchVideo = document.getElementsByClassName('launch-video');
        let that = this;
        for (var i = 0; i < launchVideo.length; i++) {
          new Waypoint({
            element: waypoints[i],
            offset: '70%',
            handler: function () {
              if ($(window).width() <= 1024) {
                // that.playVideo('video-tierra');
              }
            }
          });
        }

      },
      playVideo: function (name) {
        if (!!name) {
          $("#" + name)[0].play();
          (name == 'video-escucha') ? this.experiencia = 'escucha' : '';
        }
      },
      pausevideo: function (name) {
        $("#" + name)[0].pause();
        (name == 'video-escucha') ? this.experiencia = '' : '';
      }
    },
    components: {
      'intro': introHome,
      'blog': blog,
      'banner-newsletter': newsletter,
      'slider-productos': sliderProductos,
      'banner-contacto': bannerContacto,
    },
    computed: {
      ...mapGetters({
        launched: 'isLaunchedHome'
      }),
      ismovil: function () {
        return ($(window).height() < 800);
      }
    },
    watch: {
      'launched': function () {
        if (this.launched) {
          $('html, body').animate({
            scrollTop: $(window).height() / 2
          }, 500);
          setTimeout(function () {
            $(".contenedor-camino.dibujado").animate({ 'height': 440 }, 2000);
          }, 1000)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/colors.scss";

  video::-webkit-media-controls {
    display: none;
  }

  .intro-fake {
    height: 50vh;
    display: inline-block;
    width: 100%;
    position: relative;
  }

  .camino-container {
    padding-top: 150px;
    position: relative;
  }


  .home {
    background: $mud-brown;
  }

  .home[bloqueada=true] {
    overflow: hidden;
    height: 100vh;
    max-height: 100vh;
    padding-top: 0;
  }


  .page {
    position: relative;
    height: 870px;
  }

  .page.-la-finca {
    background: $plum;
    position: relative;
  }

  .page .titulo {
    width: 100%;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    padding-top: 40px;
    z-index: 11;
    width: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  .page .titulo .numero {
    color: currentColor;
    height: 60px;
    width: 60px;
    line-height: 60px;
    display: inline-block;
    border: 1px solid currentColor;
    border-radius: 50%;
    font-family: 'Yeseva One', cursive;
    margin-bottom: 30px;
    font-size: 24px;
    position: relative;
    opacity: 0;
    transition-duration: 1s;
    transition-delay: 0s;



    &::before,
    &::after {
      width: 80px;
      height: 80px;
      display: inline-block;
      border: 1px solid currentColor;
      border-radius: 50%;
      content: '';
      position: absolute;
      left: -12px;
      top: -12px;
      transform: scale(.70);
      opacity: 0;
    }

    &::after {
      -webkit-animation-delay: .3s;
      -o-animation-delay: .3s;
      animation-delay: .3s;
    }

  }

  .page.launched .titulo .numero {

    opacity: 1;

    &::before,
    &::after {
      animation-duration: 1s;
      animation-name: circleAnimation;
      animation-iteration-count: infinite;
    }

  }

  .page .titulo.-black .numero {
    color: black;
  }

  .page .titulo .title {
    text-align: center;
    font-size: 36px;
    height: 40px;
    overflow: hidden;
  }

  .page .titulo .title span {
    transform: translateY(-40px);
    display: inline-block;
    /*transition: 2s;*/
    -webkit-animation-delay: 0s;
    -o-animation-delay: 0s;
    animation-delay: 0s;
  }

  @for $i from 1 through 10 {
    .page .titulo .title span:nth-child(#{$i}) {
      transition:all .5s ease-out #{$i / 5 + .5}s;
    }
  }

  .page.launched .titulo .title span {
    transform: translateY(0px);
  }




  /*COMIENZA EXPERIENCIA*/
  .page.comienza-experiencia {

    background: $mud-brown;
    position: relative;

    height: 950px;

    .titulo .numero {
      transition-delay: 1s;
    }

    @for $i from 1 through 10 {
      .titulo .title span:nth-child(#{$i}) {
        transition:all .5s ease-out #{$i / 5 + 1.2}s;
      }
    }

  }

  .page.comienza-experiencia .title.first {
    margin-bottom: 0;
  }

  .page.comienza-experiencia .contenedor-imagen {
    width: 100%;
    position: absolute;
    bottom: 100px;
    left: 0;
    height: 40vw;
    max-height: 500px;
    transform: translateX(-100%);
    transition: 2s;
    transition-delay: 2s;
    will-change: transform;
    z-index: 8;
  }

  .page.comienza-experiencia .contenedor-imagen .title {
    position: absolute;
    left: 0;
    top: -64px;
    z-index: 4;
    padding-bottom: 0;
    margin-bottom: 0;
    width: auto;
    transition: 1.6s;
    transition-delay: 3.6s;
    will-change: transform;
    transform: translateX(-100%);
  }

  .page.comienza-experiencia .contenedor-imagen .imagen {
    box-shadow: 2px -3px 20px 2px rgba(0, 0, 0, 0.5);
    width: calc(100% - 100px);
    display: inline-block;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    background: url("/static/img/imagen-experiencia.jpg") center/cover no-repeat;
  }

  .page.comienza-experiencia .contenedor-imagen .imagen video {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 550px;
    z-index: 2;
    display: none;

    &::-webkit-media-controls {
      display: none;
    }

  }

  .page.comienza-experiencia .texto {
    max-width: 440px;
    width: 100%;
    position: relative;
    overflow: hidden;
    transition: 1s;
    transition-delay: 4s;
    z-index: 3;
    pointer-events: none;
  }

  .page.comienza-experiencia .texto::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 170px;
    top: 0px;
    height: 1px;
    background: #ffffff;
    display: inline-block;
  }

  .page.comienza-experiencia .texto p {
    text-align: justify;
    transform: translateY(-150%);
    transition: 1s;
    transition-delay: 4s;
  }

  .page.comienza-experiencia.launched {

    .contenedor-imagen .title {
      transform: translateX(0px);
    }

    .contenedor-imagen {
      transform: translateY(0);
    }

    .texto {
      padding: 50px 0;

      p {
        transform: translateY(0);
      }
    }

  }

  /*COMIENZA EXPERIENCIA*/


  /*LA FINCA*/

  .page.la-finca {
    width: 100%;

    background: $plum;

    height: 950px;



    .title.-ghost {
      position: absolute;
      bottom: -12px;
      right: 0;
      margin-bottom: 0;
      padding-bottom: 0;
      text-align: right;
      z-index: 3;
      overflow: hidden;
      height: 56px;
    }
  }

  .page.la-finca .contenedor-imagenes {
    height: 950px;
    width: 100%;

  }

  .page.la-finca .left {
    width: 50%;
    padding: 15px;
    transform: translateX(-100vw);
    transition: 1s;
    transition-delay: 1s;
    will-change: transform;
    z-index: 8;
    height: 100%;
    /*background: url(/static/img/la-tierra/background-intro.jpg) center/cover no-repeat;*/
  }

  .page.la-finca .left .enlace-cover {
    background: rgba(0, 0, 0, .1);
  }

  .page.la-finca .left video {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    min-width: 100%;
    min-height: 890px;
    z-index: 2;

    &::-webkit-media-controls {
      display: none;
    }

  }

  .page.la-finca .left p {
    text-align: justify;
    max-width: 400px;
    margin-bottom: 40px;
    z-index: 6;
    overflow: hidden;
  }

  .page.la-finca .left p span {
    transform: translateY(-300px);
    opacity: 0;
    transition-delay: 2.5s;
    transition-duration: 1s;
  }

  .page.la-finca .right {
    width: 50%;
    overflow-x: hidden;
    height: 100%;
  }

  .page.la-finca .right article {
    flex-grow: 2;
    width: 100%;
    position: relative;
    transform: translateX(100%);
    transition: .7s;
    will-change: transform;
  }

  @for $i from 1 through 4 {
    .page.la-finca .right article:nth-child(#{$i}) {
      transition-delay: #{$i / 2 + 1.1}s;
    }
  }

  .page.la-finca .btn {
    min-width: 300px;
  }

  [data="tierra"] {
    /*background: url("/static/img/la-tierra/background-intro.jpg") center left/cover no-repeat;*/
  }

  [data="azafran"] {
    background: url("/static/img/home-azafran.jpg") center/cover no-repeat;
  }
[data="queseria"] {
    background: url("/static/img/queso.jpg") center/cover no-repeat;
  }

  [data="bodega"] {
    background: url("/static/img/home-bodega.jpg") center/cover no-repeat;
  }

  [data="almanzara"] {
    background: url("/static/img/home-almanzara.jpg") center/cover no-repeat;
  }

  .page.la-finca.launched {

    .left {
      transform: translateX(0);
    }

    .right article {
      transform: translateX(0);
    }

    .left p span {
      opacity: 1;
      transform: none;
    }
  }

  /*----FIN LA FINCA----*/



  /*PRODUCTOS*/

  .page.productos {
    background: black;
    position: relative;
    /*z-index: 2;*/
  }





  .page.contacto .contenedor-banner {
    width: 100%;
    display: inline-block;
    z-index: 8;
    position: relative;
    background: white;
  }

  .page.blog {
    padding-top: 100px;
    background: white;
  }


  .page.blog .titulo {
    background: $plum;
    padding: 25px;
    width: auto;
    border-radius: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .page.blog .titulo .numero {
    margin-bottom: 0;
  }




  /*EXPERIENCIA*/
  .page.experiencia {
    background: $plum;
    padding-bottom: 100px;
    /*display: inline-block;*/
    width: 100%;
    padding-top: 250px;
    position: relative;
    overflow-x: hidden;

    .title.-ghost {
      position: absolute;
      bottom: -18px;
      right: 50%;
      width: auto;
      padding-bottom: 0;
      opacity: 0;
      transform: translateY(-20px);
      transition: .7s;
      transition-delay: 1.1s;
      width: 500px;
      z-index: 3;
    }

    .contenedor-vive,
    .contenedor-escucha {
      width: 50%;
      transition-delay: 1s;
      transition-duration: 1s;
    }

    .banner-vive-aldonza,
    .banner-escucha-aldonza {
      width: 100%;
      height: 390px;
      transition: 1s;
      will-change: transform;
      z-index: 8;
    }

    .contenedor-vive {
      transform: translateX(-100vw);
    }

    .contenedor-escucha {
      transform: translateX(100vw);
    }

    .banner-vive-aldonza {

      position: relative;
      background: $plum;

      video {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        min-height: 100%;
        min-width: 100%;
        display: inline-block;

      }

    }


    &.launched {

      .title.-ghost {
        opacity: .5;
        transform: translateY(0);
      }

      .contenedor-vive,
      .contenedor-escucha {
        transform: translate(0);
        transition-delay: 0;

      }

      .banners[active="vive"] {
        .banner-vive-aldonza {
          transform: scale(1.1) translate(0);
          transition-delay: 0;
        }

        .banner-escucha-aldonza {
          transform: scale(.9) translate(0);
          transition-delay: 0;
        }
      }

      .banners[active="escucha"] {
        .banner-vive-aldonza {
          transform: scale(.9) translate(0);
          transition-delay: 0;
        }

        .banner-escucha-aldonza {
          transform: scale(1.1) translate(0);
          transition-delay: 0;
        }
      }

    }

  }



  .page.contacto {
    height: auto;
  }



  /*CAMINO*/

  .contenedor-camino {
    position: absolute;
    left: 0;
    top: 150px;
    z-index: 13;
    height: 4604px;
    width: 100%;
    pointer-events: none;
    opacity: .4;
  }


  .contenedor-camino svg {
    width: 100%;
    height: 4604px;
  }

  .contenedor-camino.dibujado {
    height: 0;
    opacity: 1;
    overflow: hidden;
  }

  .contenedor-camino .down {
    width: 15px;
    position: absolute;
    top: 403px;
    right: 50%;
    margin-right: -530px;
    opacity: 1;
    animation-name: moveDown;
    animation-iteration-count: infinite;
    animation-duration: 1s;
    animation-delay: 2s;
  }

  @keyframes moveDown {
    0% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(10px);
    }

    100% {
      transform: translateY(0);
    }

  }


  .st0 {
    fill: none;
    stroke: #FFFFFF;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 11.84, 12;
  }

  .st1 {
    fill: none;
    stroke: #FFFFFF;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 11.84, 11;
  }

  .st2 {
    fill: none;
    stroke: #1D1D1B;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 11.84, 12;
  }

  .st3 {
    fill: none;
    stroke: #FFFFFF;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 11.84, 11.84;
  }

  .contacto-movil {
    display: none;
  }

  @media screen and (max-width: 1100px) {
    .contenedor-camino {
      display: none;
    }

    .camino-container {
      padding-top: 0;
    }

    .page.comienza-experiencia {
      height: 850px;
    }

    .plum-border.-fixed::before {
      display: none;
    }

    .page.la-finca {
      height: 660px;

      .title.-ghost {
        font-size: 24px;
        letter-spacing: 2px;
        height: 30px;
        bottom: -8px;
      }
    }




    .page.la-finca .left {
      background: url(/static/img/la-tierra/background-intro.jpg) center/cover no-repeat;
    }


    .page.la-finca .contenedor-imagenes {
      height: 660px;
    }

    .banner-escucha-aldonza {
      background: url("/static/img/banner-escucha-aldonza.png") center/cover no-repeat;

      video {
        display: none;
      }

      &::before {
        left: 50%;
        top: 50%;
        margin-top: -100px;
        margin-left: -100px;
        animation-name: breath;
        animation-duration: 5s;
        animation-iteration-count: infinite;
      }
    }

    @keyframes breath {
      from {
        transform: scale(1);
      }

      50% {
        transform: scale(1.2);
      }

      to {
        transform: scale(1);
      }
    }

    .page.experiencia {
      padding-bottom: 0;
      height: 760px;
    }

    .page.contacto {
      padding-top: 180px;
      background: white;
    }

    .page.productos {
      height: 700px;
    }

  }

  @media screen and (max-height: 800px) {
    .contacto-movil {
      display: inline-block;
    }
  }

  @media screen and (max-width: 769px) {
    .page.experiencia .title.-ghost {
      display: none;
    }
  }


  @media screen and (max-width: 700px) {
    .page .titulo {
      width: 100%;

      .title {
        font-size: 24px;
        height: 30px;
      }
    }

    .page.comienza-experiencia {
      height: 600px;

      .contenedor-imagen {
        height: 33vh;
        bottom: 50px;

        .title {
          top: -80px;
          text-align: center;
        }

        .texto {
          padding: 25px;
          height: 33vh;
          background: rgba(0, 0, 0, .4);
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          display: flex;
          justify-content: center;
          -webkit-justify-content: center;
          -ms-align-items: center;
          align-items: center;

          p {
            text-align: left;
          }
        }

        .imagen {
          width: 100%;
          height: 33vh;
        }
      }
    }

    .page.la-finca {
      height: auto;
      padding-top: 200px;

      .contenedor-imagenes {
        height: auto;
      }

      .left {
        height: 100vw;
        padding-top: 0px;
        width: 100%;

        .enlace-cover {
          background: rgba(0, 0, 0, 0.4);
        }

        p {
          text-align: left;
        }
      }

      .right {
        width: 100%;
        height: auto;

        article {
          height: 33.3333vh;
        }
      }
    }

    .page.productos {
      height: auto;
    }

    .page.experiencia {
      height: auto;
      padding-top: 200px;
      padding-bottom: 100px;

      .container {
        padding: 0;
      }

      &.launched {

        .contenedor-vive,
        .contenedor-escucha {
          width: 100%;

          .banner-escucha-aldonza,
          .banner-vive-aldonza {
            height: 50vh;
          }
        }
      }

    }

    .page.blog {
      padding-top: 70px;
    }

    .banner-escucha-aldonza p {
      text-align: left;
    }


  }
</style>


// WEBPACK FOOTER //
// src/components/views/home/home.vue